module.exports = __webpack_public_path__ + "img/login-hockeyapp-bg-0201fef4a94662cb5f74a56d6e615ee2.svg";